import { ApplicationRef, ComponentFactoryResolver, Injector } from '@angular/core';
import * as i0 from "@angular/core";
var CustomCompileService = /** @class */ (function () {
    function CustomCompileService(injector, resolver, appRef) {
        this.injector = injector;
        this.resolver = resolver;
        this.appRef = appRef;
    }
    CustomCompileService.prototype.compile = function (component, onAttach) {
        var _this = this;
        var compFactory = this.resolver.resolveComponentFactory(component);
        var compRef = compFactory.create(this.injector);
        if (onAttach) {
            onAttach(compRef);
        }
        this.appRef.attachView(compRef.hostView);
        compRef.onDestroy(function () { return _this.appRef.detachView(compRef.hostView); });
        var div = document.createElement('div');
        div.appendChild(compRef.location.nativeElement);
        return div;
    };
    CustomCompileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomCompileService_Factory() { return new CustomCompileService(i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.ApplicationRef)); }, token: CustomCompileService, providedIn: "root" });
    return CustomCompileService;
}());
export { CustomCompileService };
